import { useCommonUserData } from '@common/react/user';
import { useStytchUser } from '@stytch/nextjs';

export const useUserData = () => {
    const { user, isInitialized } = useStytchUser();
    return useCommonUserData({ user, isInitialized });
};
